import { OfflinePromotion } from '../redux/types';
import { Logger } from '../utils/logger';
import { HrpsApiClient } from './HrpsApiClient';

export const getOfflinePromotions = async (resellerId: string, promotionIds: string[]): Promise<OfflinePromotion[]> => {
    Logger.info('Getting offline promotions', { resellerId, promotionIds });
    return new HrpsApiClient()
        .callHrps('getOfflinePromotions', { resellerId, promotionIds })
        .then((response) => {
            return response.data.promotions;
        })
        .catch((error) => {
            Logger.debug('Error getting offline promotions: ', error.message);
            throw error;
        });
};
